import React, { useState, useContext, useEffect, useMemo } from "react";
import { Modal, Button, Row } from "reactstrap";
import { FormattedMessage, IntlShape, useIntl } from "react-intl";
import { getValueOrEmpty } from "services/util/StringUtil";
import CloseButton from "components/framework/modals/CloseButton";
import { handleError } from "services/util/ApiUtil";
import { AppContext } from "services/appContext/AppContext";
import { OrderApi } from "services/apis/OrderApi";
import { OrderDto } from "services/apis/types/order/OrderDto";
import ReactTable from "components/framework/table/ReactTable";
import { OrderType } from "services/apis/types/order/OrderType";
import { LoadingIndicator } from "components/framework/loadingIndicator/LoadingIndicator";
import { SinchApi } from "services/apis/SinchApi";

type Props = {
  closeModal: () => void;
  order?: any;
  isSinch?: boolean;
};

type ColumnFilterSort = {
    isSorted?: boolean;
    isSortedDesc?: boolean;
}

export default function OrderTnsTable(props: Props) {
  const intl = useIntl();
  const { appContext } = useContext(AppContext);
  const [phoneNumbers, setPhoneNumbers] = useState<any[]>();
  const theme = appContext.theme;
  const columns = useMemo(() => getColumns(intl), [intl]);
  const [showLoadingIndicator, setShowLoadingIndicator] = useState(false);
 
  useEffect(() => {
    setShowLoadingIndicator(true);
    getOrderDetails();
  },[props.order])

  const getOrderDetails = () => {
    const isDisasterRecovery = props.order.orderType === OrderType.DisasterRecovery;
    const isRestore = props.order.orderType === OrderType.Restore;
    const orderDetails = isDisasterRecovery ? OrderApi.getDR(props.order?.orderId, props.order?.tenant) : props.isSinch ? SinchApi.getSinch(props.order?.orderId, props.order.tenant) : OrderApi.get(props.order?.orderId, props.order?.tenant)
    orderDetails
    .then((response) => {
        const orderPhoneNumbers = response.numbers.map((x) => {
         return { phoneNumber: x.phoneNumber };
      })
      setPhoneNumbers(orderPhoneNumbers);
    })
    .catch((error) => {handleError(error)})
    .finally(() => {
      setShowLoadingIndicator(false);
    })
  }

  return (
    <Modal className="modal-dialog-centered modal-md" isOpen={true}>
      <div className="modal-header">
        <h5 className="modal-title">
          
        </h5>
        <CloseButton close={props.closeModal} />
      </div>
        <div>
            { showLoadingIndicator ? (
                <LoadingIndicator white />
              ) : (
                <ReactTable
                    title={intl.formatMessage({ id: "explore.table.title" })}
                    columns={columns}
                    data={phoneNumbers}
                />
              )
            }
        </div>
    </Modal>
  );
}

const getColumns = (intl: IntlShape) => {
    return[{
        Header: intl.formatMessage({ id: "explore.table.title" }),
        accessor: "phoneNumber",
        Cell: (cell: any) => getValueOrEmpty(cell.value)
      }
    ]
}
